module.exports = function() {
  return new Worker(__webpack_public_path__ + "55e7afea05da1a758215.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/services.worker.js
// module id = 94
// module chunks = 0